import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './conserto_relogio.css';
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasProdutos, trazerTituloProdutos } from "../utils/utils";

const RelogiosAcessorios = () => {

  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Relógios";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />
      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.relogiosAcessorios})` }}>
        <div className="servico-hero-overlay">
          <h1>Relógios</h1>
          {/*<p>Para quem procura por relógios e acessórios</p>*/}
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloProdutos()}</h2>
        </article>

        {/* Aqui começa todo o conteudo */}
        {/* Seção de Grade de Produtos - Relógios e Acessórios */}
        <section className="acessorios-grid">
          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.relogiosPulsos} alt="" /></div>
            <h3>Pulso</h3>
            <p>Modelos analógicos, digitais e smartwatches.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.relogiosParede} alt="" /></div>
            <h3>Parede</h3>
            <p>Relógios musicais, tic-tac, contínuo e pêndulo.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.desperadores} alt="" /></div>
            <h3>Despertadores</h3>
            <p>Modelos analógicos e digitais para mesa e cabeceira.</p>
          </div>

          <div className="acessorio-card">
            <div className="acessorio-ilustracao"><img src={assets.acessoriosRelogios} alt="" /></div>
            <h3>Acessórios</h3>
            <p>Pulseiras, passadores e pinos.</p>
          </div>

        </section>

        {/* Aqui termina todo o conteudo */}

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasProdutos('relógios')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('relógios')}>
            Solicitar disponibilidade
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>

      </main>
      <Footer />
    </div>
  )
}

export default RelogiosAcessorios;